module.exports = __webpack_public_path__ + "static/media/拍照速算识别).cb6a1313.png";